import { call, put, takeLatest } from 'redux-saga/effects';
import handleException from '../services/handleException';
import { listChannel } from '../utils/channel';
import { GET_LIST_CHANNEL_SHIPMENT_SUCCESS, GET_LIST_CHANNEL_SHIPMENT } from '../actions/shipmentAction';

function* getListChannelShipmentSaga() {
    yield takeLatest(GET_LIST_CHANNEL_SHIPMENT, getListChannelShipmentHandle)
}

function* getListChannelShipmentHandle(action) {
    try {
        const response = yield call(listChannel, action.payload)

        if (response.data.code === 10001) {
            yield put({ type: GET_LIST_CHANNEL_SHIPMENT_SUCCESS, payload: response })
        } else {
            handleException(response)
        }
    } catch (error) {
        handleException(error)
    }
}

export default getListChannelShipmentSaga


// WEBPACK FOOTER //
// ./src/sagas/getListChannelShipmentSaga.js